import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMunicipalExecutiveAPI } from "../../services/api";
import ErrorMessage from "../ui_elements/ErrorMessage";
import defaultPhoto from "../../assets/imgs/default_photo.svg";

const ExecutivePage = () => {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getMunicipalExecutiveAPI()
      .then(({ data }) => setPeople(data))
      .catch(() => setError("Não foi possível carregar os dados."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="py-8 text-center text-gray-500">Carregando...</div>;
  if (error) return (
    <ErrorMessage
      title="Informações indisponíveis no momento"
      description="Não foi possível carregar os dados da Gestão Municipal. Nossa equipe já está trabalhando para restabelecer o acesso o mais breve possível."
    />
  );

  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-10">
          {people.map((person) => (
            <div
              key={person.id}
              className="bg-gray-50 rounded-2xl shadow-lg text-center p-8"
            >
              <img
                src={person.photo || defaultPhoto}
                alt={person.name}
                className="w-40 h-40 rounded-full object-cover mx-auto mb-4 shadow-md"
                onError={(e) => { e.target.src = defaultPhoto; e.target.onerror = null; }}
              />
              <h3 className="text-2xl font-bold text-blue-900 mb-1">
                {person.name}
              </h3>
              <p className="text-sm text-gray-500 mb-6">{person.role}</p>
              <button
                onClick={() => navigate(person.path)}
                className="bg-blue-600 text-white text-sm font-semibold px-6 py-2 rounded-md hover:bg-blue-700"
              >
                Mais informações
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExecutivePage;
